/* global REDUX_DEVTOOLS */

import { applyMiddleware, createStore, compose } from "redux";
import promise from "redux-promise";
import { createLogger } from "redux-logger";
import createSagaMiddleware from "redux-saga";
import { routerMiddleware } from "react-router-redux";
import state from "reducers";

import createApiClient from "helpers/api-client";
import createAuthClient from "helpers/auth-client";
import createEstimationClient from "clients/estimation-api";
import createAnalyticsClient from "helpers/analytics-client";
import createAccountsClient from "clients/accounts";
import createAnalyticsV2Client from "clients/analytics-v2";
import createImageServiceClient from "clients/image-service";
import createRbfClient from "clients/rbf";
import createIntegrationsClient from "clients/integrations";

import { SAGAS } from "sagas";
import { supportsUserTimingApi } from "utils/timing";
import { addPerformanceMeasure } from "actions/metrics";
import actionTimingMiddleware from "./actionTimingMiddleware";

export default function configureStore(history) {
  const authClient = createAuthClient();
  const accountsClient = createAccountsClient(authClient);
  const apiClient = createApiClient(authClient);
  const analyticsClient = createAnalyticsClient(authClient);
  const analyticsV2Client = createAnalyticsV2Client(authClient);
  const estimationClient = createEstimationClient(authClient);
  const imageServiceClient = createImageServiceClient(authClient);
  const rbfClient = createRbfClient(authClient);
  const integrationsClient = createIntegrationsClient(authClient);

  const sagaMiddleware = createSagaMiddleware({
    context: {
      accounts: accountsClient,
      api: apiClient,
      auth: authClient,
      analytics: analyticsClient,
      analyticsV2: analyticsV2Client,
      estimation: estimationClient,
      image: imageServiceClient,
      rbf: rbfClient,
      integrations: integrationsClient
    }
  });

  let composeEnhancers = compose;
  let middlewares = [sagaMiddleware, promise];

  if (typeof REDUX_DEVTOOLS !== undefined && REDUX_DEVTOOLS === true) {
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    } else {
      middlewares = [...middlewares, createLogger()];
    }
  }

  // Build the middleware for intercepting and dispatching navigation actions
  if (history) middlewares = [...middlewares, routerMiddleware(history)];

  // Add action timing middleware
  /* global COLLECT_TIMING_REPORTS */
  if (COLLECT_TIMING_REPORTS && supportsUserTimingApi()) {
    middlewares = [...middlewares, actionTimingMiddleware];
  }

  const store = createStore(
    state,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  SAGAS.forEach(saga => sagaMiddleware.run(saga));

  store.dispatch(addPerformanceMeasure("action.app.bootstrap"));

  return store;
}
